import { TabContentSkeleton } from "@/admin/AdminConsolePage"
import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import MetaDetails from "@/main/page/MetaDetails"
import Relay from "@/relay/relayUtils"
import { graphql, useLazyLoadQuery } from "react-relay"
import DashboardPageContent from "./DashboardPageContent"
import { ForYouDashboardQuery } from "@/dashboard/__generated__/ForYouDashboardQuery.graphql"

function ForYouDashboard() {
  const activeOrganization = useActiveOrganization()

  const { organization } = useLazyLoadQuery<ForYouDashboardQuery>(
    graphql`
      query ForYouDashboardQuery($id: ID!) {
        organization: node(id: $id) {
          ... on Organization {
            id
            forYouDashboard {
              id
              layout
              app {
                customAppTitle
                badge {
                  icon
                  ...BadgeFragment
                }
                ...HeaderContentFragment
              }
            }
          }
        }
      }
    `,
    { id: activeOrganization?.id || "" }
  )

  if (!organization?.forYouDashboard) return null

  return (
    <MetaDetails
      metaDetailsForSharing={{
        title: activeOrganization?.name,
        url: window.location.href,
        description: activeOrganization?.description || "",
        coverPhoto: activeOrganization?.cover || "",
      }}
      metaTitle={activeOrganization?.name}
    >
      <DashboardPageContent
        dashboardId={organization.forYouDashboard.id}
        layout={organization.forYouDashboard.layout}
        HeaderProps={{
          appKey: organization.forYouDashboard.app,
        }}
      />
    </MetaDetails>
  )
}

export default Relay.withSkeleton({
  component: ForYouDashboard,
  skeleton: TabContentSkeleton,
})
